import { Box } from 'braid-design-system';
import type React from 'react';

import { skeleton } from './styles.css';

interface SkeletonProps {
  loading: boolean;
  numberOfCharacters: number;
  height?: number;
}

export const Skeleton: React.FC<React.PropsWithChildren<SkeletonProps>> = ({
  children,
  loading = false,
  numberOfCharacters = 10,
  height,
}) => {
  if (loading) {
    return (
      <Box
        background="neutralLight"
        borderRadius="full"
        className={skeleton}
        style={{ height: height ?? 'auto' }}
      >
        {Array(numberOfCharacters + 1).join('_')}
      </Box>
    );
  }

  return <>{children}</>;
};
